import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type ActionFooterOrgVisibilityFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id' | 'displayName' | 'name'>
  & { prefs: (
    { __typename: 'Organization_Prefs' }
    & Pick<Types.Organization_Prefs, 'permissionLevel'>
  ) }
);

export const ActionFooterOrgVisibilityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionFooterOrgVisibility' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prefs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissionLevel' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseActionFooterOrgVisibilityFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      ActionFooterOrgVisibilityFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseActionFooterOrgVisibilityFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<ActionFooterOrgVisibilityFragment>,
    'data'
  > {
  data?: ActionFooterOrgVisibilityFragment;
}

export const useActionFooterOrgVisibilityFragment = ({
  from,
  returnPartialData,
  ...options
}: UseActionFooterOrgVisibilityFragmentOptions): UseActionFooterOrgVisibilityFragmentResult => {
  const result = Apollo.useFragment<ActionFooterOrgVisibilityFragment>({
    ...options,
    fragment: ActionFooterOrgVisibilityFragmentDoc,
    fragmentName: 'ActionFooterOrgVisibility',
    from: {
      __typename: 'Organization',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as ActionFooterOrgVisibilityFragment };
};
